import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propArrayShape, propBool, propChildren, propFunc, propNumber, propShape, propStr, } from '../../../helpers/custom-prop-types';
import SlideViewerLeftComponent from './LeftComponent/SlideViewerLeftComponent';
import SlideList from './Slider/SlideList';
import VerticalButton from './Slider/VerticalButton';
const SlideViewerBase = (props) => {
    const { canCheckOfLeftSlideItems, changeImageIndexMap, changeSlideListIndex, className, containerId, imageIndex, imageIndexMap, onChangeSelectSlide, onClickImage, pageDownSlide, pageUpSlide, rightComponent, scrollingRef, selectMap, setSliderRef, showPageDown, showPageUp, slide, slideListIndex, slideScrollTo, slides, unit, } = props;
    return (_jsxs("div", Object.assign({ className: clsx('slide_viewer', className) }, { children: [_jsx(SlideViewerLeftComponent, { canCheck: canCheckOfLeftSlideItems, imageIndex: imageIndexMap[slideListIndex] || 0, images: slide.pages, onChangeSelectSlide: onChangeSelectSlide, onClickImage: onClickImage, selectMap: selectMap, unit: unit }), _jsx("div", Object.assign({ className: 'slide_viewer_main_box' }, { children: _jsx("div", Object.assign({ className: 'slide_viewer_main' }, { children: _jsxs("div", Object.assign({ className: 'slide_viewer_main_image_box' }, { children: [_jsx(VerticalButton, { className: 'slide_viewer_main_slide_up', iconClassName: 'up', isShow: showPageUp, onClick: pageUpSlide, text: 'Page Up' }), _jsx(SlideList, { changeImageIndexMap: changeImageIndexMap, changeSlideListIndex: changeSlideListIndex, className: 'slide_viewer_main_image_slider', containerId: containerId, imageIndexMap: imageIndexMap, scrollingRef: scrollingRef, setSliderRef: setSliderRef, slideListIndex: slideListIndex, sliderListClassName: 'slide_viewer_main_slide_list', slides: slides, slideScrollTo: slideScrollTo }), _jsx(VerticalButton, { className: 'slide_viewer_main_slide_down', iconClassName: 'down', isShow: showPageDown, onClick: pageDownSlide, text: 'Page Down' })] })) })) })), _jsxs("div", Object.assign({ className: 'slide_viewer_pager' }, { children: [_jsx("span", Object.assign({ className: 'number_first' }, { children: imageIndex + 1 })), _jsx("span", { children: "/" }), _jsx("span", Object.assign({ className: 'number_last' }, { children: slide.pages.length }))] })), rightComponent] })));
};
SlideViewerBase.propTypes = {
    canCheckOfLeftSlideItems: propBool(),
    changeImageIndexMap: propFunc().isRequired,
    changeSlideListIndex: propFunc().isRequired,
    className: propStr(),
    containerId: propStr().isRequired,
    imageIndex: propNumber().isRequired,
    imageIndexMap: propShape().isRequired,
    onChangeSelectSlide: propFunc(),
    onClickImage: propFunc().isRequired,
    pageDownSlide: propFunc().isRequired,
    pageUpSlide: propFunc().isRequired,
    rightComponent: propChildren(),
    scrollingRef: propShape().isRequired,
    selectMap: propShape(),
    setSliderRef: propFunc().isRequired,
    showPageDown: propBool().isRequired,
    showPageUp: propBool().isRequired,
    slide: propShape().isRequired,
    slideListIndex: propNumber().isRequired,
    slideScrollTo: propFunc().isRequired,
    slides: propArrayShape().isRequired,
    unit: propShape(),
};
SlideViewerBase.defaultProps = {
    canCheckOfLeftSlideItems: false,
    className: '',
    onChangeSelectSlide: () => { },
    rightComponent: null,
    selectMap: null,
    unit: null,
};
export default SlideViewerBase;
